@for (evidence of evidenceList; track evidence) {
  <div class="fields">
    <div class="field-container">
      <div class="field-key">Found in</div>
      <div class="field-value-container">
        <app-anchor-link navigation="" (clicked)="openEvidence(evidence)">
          <span appLongTextTooltip class="field-link-value__text">
            {{ getStepType(evidence) | beautifyDisplayString }}
          </span>
        </app-anchor-link>
        {{ getLocation(evidence) }}
      </div>
    </div>
    <div class="field-container">
      <div class="field-key">Core Evidence</div>
      <div class="field-value-container">
        @if (isSensitiveContent(evidence)) {
          <div class="field-value-transcript">
            <div class="field-value-transcript-string" [innerHtml]="getCoreEvidence(evidence)"></div>
            <app-get-sensitive-data-input-action
              *ngIf="isSensitiveContent(evidence)"
              [sensitiveDataMethod]="getSensitiveDataMethod(evidence)"
              [showPopupBtn]="true"
              [content]="''"
              [sensitiveDataIndexes]="getEvidenceSensitiveIndexes(evidence)"
            >
            </app-get-sensitive-data-input-action>
          </div>
        } @else {
          <div class="field-value" [innerHtml]="getCoreEvidence(evidence)"></div>
        }
      </div>
    </div>
  </div>
}
